import { useEffect, useState } from "react";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/ui/Breadcrumb";
import routePaths from "../../routes/routePaths";

const DEFAULT_THUMB = "/images/default-blog-thumbnail.svg";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const fetchPost = async () => {
      const ref = doc(db, "blogs", slug);
      const snap = await getDoc(ref);
      if (snap.exists()) setPost(snap.data());
    };
    const fetchRelated = async () => {
      const q = query(
        collection(db, "blogs"),
        where("status", "==", "published"),
        orderBy("createdAt", "desc"),
        limit(6)
      );
      const snap = await getDocs(q);
      const docs = snap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(item => item.slug !== slug)
        .slice(0, 4); // Loại bài hiện tại, lấy 4 bài khác
      setRelated(docs);
    };
    fetchPost();
    fetchRelated();
  }, [slug]);

  if (!post) return null;

  return (
    <div className="max-w-6xl mx-auto py-12 px-4">
      <Breadcrumb items={[
        { label: t("blog.breadcrumbs"), path: routePaths.blog },
        { label: post.title?.[i18n.language] || "" }
      ]} />

      <h1 className="text-2xl md:text-3xl font-extrabold mb-7 text-primary">
        {post.title?.[i18n.language] || post.title?.vi}
      </h1>

      <img
        src={post.coverImage || DEFAULT_THUMB}
        alt={post.title?.[i18n.language] || ""}
        className="mb-8 rounded w-full object-cover bg-card shadow border-2 border-border"
      />

      <div
        className="prose prose-sm sm:prose lg:prose-lg max-w-none prose-h2:text-primary prose-h3:text-primary prose-a:text-primary prose-blockquote:border-l-primary text-text"
        dangerouslySetInnerHTML={{
          __html: post.content?.[i18n.language] || post.content?.vi,
        }}
      />

      {/* Danh sách bài viết liên quan */}
      {related.length > 0 && (
        <div className="mt-16">
          <h2 className="text-xl font-bold mb-6 text-primary">
            {t("blog.related")}
          </h2>
          <ul className="grid md:grid-cols-2 gap-6">
            {related.map((item) => (
              <li
                key={item.id}
                className="flex items-center gap-4 bg-card rounded p-4 shadow border border-border hover:border-primary hover:shadow-lg transition cursor-pointer"
                onClick={() => navigate(`/blog/${item.slug}`)}
              >
                <img
                  src={item.coverImage || DEFAULT_THUMB}
                  alt={item.title?.[i18n.language] || item.title?.vi}
                  className="w-16 h-16 object-cover rounded bg-card border border-border flex-shrink-0"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-base font-bold text-primary hover:text-secondary transition line-clamp-2">
                    {item.title?.[i18n.language] || item.title?.vi}
                  </div>
                  <div className="text-text2 text-sm line-clamp-1">
                    {item.excerpt?.[i18n.language] || item.excerpt?.vi}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
